import { render, staticRenderFns } from "./ShopeeProductForm.vue?vue&type=template&id=5a0d8774&"
import script from "./ShopeeProductForm.vue?vue&type=script&lang=js&"
export * from "./ShopeeProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports